import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useNetwork, useWaitForTransaction } from "wagmi";
import { NUM_CONFIRMATIONS } from "../config/constants";
import { getExplorerTxLink } from "../config/resolver";

// TODO: styling

function ProcessingModalEmpty() {
  return (
    <ModalContent>
      <ModalHeader>Waiting for you to do something</ModalHeader>
      <ModalBody>Approve the transaction in your wallet</ModalBody>
      <ModalFooter>zzzzz</ModalFooter>
    </ModalContent>
  );
}

function ProcessingModalLoading({ txHash }) {
  const { chain } = useNetwork();

  return (
    <ModalContent>
      <ModalHeader>Processing your transaction</ModalHeader>
      <ModalBody>
        <Text>Now we gotta wait for the network to do its magic</Text>
        <Link href={getExplorerTxLink(chain, txHash)} isExternal>
          {txHash}
        </Link>
      </ModalBody>
      <ModalFooter>zzzzz</ModalFooter>
    </ModalContent>
  );
}

function ProcessingModalError({ error, onClose }) {
  return (
    <ModalContent>
      <ModalHeader>Something's wrong</ModalHeader>
      <ModalBody>
        <Text>Uh... oh...</Text>
        <Text>{error.message}</Text>
      </ModalBody>
      <ModalFooter>
        <Text>Who you gonna call?</Text>
        <Button onClick={onClose} ml="1em" colorScheme="teal" size="sm">
          Close this
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}

function ProcessingModalSuccess({ onClose, txHash }) {
  const { chain } = useNetwork();

  return (
    <ModalContent>
      <ModalHeader>Yay</ModalHeader>
      <ModalBody>
        <Text>Done!</Text>
        <Link href={getExplorerTxLink(chain, txHash)} isExternal>
          {txHash}
        </Link>
      </ModalBody>
      <ModalFooter>
        <Text>Now you can go back to what's important</Text>
        <Button onClick={onClose} ml="1em" colorScheme="teal" size="sm">
          Close this
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}
export function ProcessingModal({ isOpen, onClose, tx }) {
  const { error, status } = useWaitForTransaction({ hash: tx?.hash, confirmations: NUM_CONFIRMATIONS });

  return (
    <Modal isOpen={isOpen} size="xl" isCentered>
      <ModalOverlay />
      {!tx ? (
        <ProcessingModalEmpty />
      ) : (
        <>
          {status === "loading" && <ProcessingModalLoading txHash={tx.hash} />}
          {status === "error" && <ProcessingModalError onClose={onClose} error={error} />}
          {status === "success" && <ProcessingModalSuccess onClose={onClose} txHash={tx.hash} />}
          {tx?.txError && <ProcessingModalError onClose={onClose} error={tx.txError} />}
        </>
      )}
    </Modal>
  );
}
